<template>
    <!-- 메인팝업 -->
    <div class="popup" :class="{ active: main_popup && isMobile }" v-if="popupCnt > 0">
        <div class="main-popup">
            <h3 class="main-popup--title">
                <img src="/resource/img/main/main-popup--title--mom.png" alt="">
                <strong>POPUP ZONE</strong>
            </h3>
            <div class="main-popup__cont">
                <p class="main-popup__cont--top">팝업 전체 · <span>{{popupCnt}}개</span></p>
                <swiper
                class="main-popup-swiper"
                :modules="modules"
                :slidesPerView="1"
                :loop="true"
                :speed="600"
                :spaceBetween="40"
                centeredSlides="true" 
                :breakpoints="{
                    720: { slidesPerView: 2 },
                    1312: { slidesPerView: 3 }
                }"
                :navigation="{
                    nextEl: '.main-popup-swiper__button.next',
                    prevEl: '.main-popup-swiper__button.prev'
                }"
                navigation
                >
                    <swiper-slide class="main-popup__item" v-for="popup in popupList" :key="popup.attachBag.bannerImg[0].attachNo">
                        <a :href="popup.link ? popup.link : 'javascript:;'" :target="popup.target">
                        <img 
                            :src="`/displayFile.do?attachNo=${popup.attachBag.bannerImg[0].attachNo}`"
                            :alt="popup.attachBag.bannerImg[0].altValue || '이미지'"
                            v-if="popup.attachBag.bannerImg"
                        />
                        </a>
                    </swiper-slide>
                </swiper>
                <div class="main-popup-swiper__button-wrap">
                    <button class="main-popup-swiper__button prev"></button>
                    <button class="main-popup-swiper__button next"></button>
                </div>
            </div>
            <div class="main-popup__button-wrap">
                <a href="javascript:;" class="main-popup__button02" @click="closePopup">오늘 하루 열지 않기</a>
                <a href="javascript:;" class="main-popup__button" @click.prevent="main_popup_close"></a>
            </div>
        </div>
    </div>
    <div class="intro">
        <div class="intro__bg intro__bg1"></div>
        <div class="intro__bg intro__bg2">
            <div></div>
        </div>
        <div class="intro__bg intro__bg3"></div>
    </div>
    <div class="main">
        <div class="note" :class="{'top': isScrolled}">
            <a href="/kr/mypage/babyNote/babyNoteMain" class="note__link">
                <div class="note__img">
                    <img src="@/assets/resource/icon/main-note.png" alt="">
                    <img src="@/assets/resource/icon/main-note02.gif" alt="">
                </div>
                <p class="note__desc">이대엄마아기수첩</p>
            </a>
        </div>
        <section class="sec main-kv">
            <div class="popup2 mo-none" v-if="main_popup && popupCnt > 0">
                <swiper :spaceBetween="30" :pagination="{
                      clickable: true,
                    }" :modules="modules" class="popupSwiper">
                    <swiper-slide class="slide" v-for="(popup, index) in popupList" :key="index">
                        <a :href="popup.link" :target="popup.target" class="slide__link">
                            <img class="momPop_img"
                             :src="`/displayFile.do?attachNo=${ popup.attachBag.bannerImg[0].attachNo }`" :alt="popup.attachBag.bannerImg[0].altValue || '이미지'" v-if="popup.attachBag.bannerImg">
                        </a>
                    </swiper-slide>
                </swiper>
                <div class="popup2__btn">
                    <button type="button" @click="closePopup">오늘하루 열지 않기</button>
                    <button type="button" @click="main_popup_close">닫기</button>
                </div>
            </div>
            <!-- 동영상 -->
            <div class="main-kv__video">
                <video src="@/assets/resource/video/baby-video01.mp4" class="mo-none" autoplay muted loop></video>
                <!-- mo -->
                <img src="@/assets/resource/img/main_visual01.png" class="pc-none" alt="">
            </div>

            <!-- 탭메뉴 -->
            <div class="main-kv__teb">
                <ul class="main-kv__list">
                    <li class="main-kv__item">
                        <a href="javascript:;" class="main-kv__link" @click="showPopup('firstVisible')">첫 진료 예약</a>
                    </li>
                    <li class="main-kv__item">
                        <a href="https://pf.kakao.com/_xdvyYT/chat?bot=true" target="_blank" class="main-kv__link">알림톡 서비스</a>
                    </li>
                    <li class="main-kv__item">
                        <a href="javascript:;" @click="goReservation" class="main-kv__link">진료예약</a>
                    </li>
                    <li class="main-kv__item">
                        <router-link to="/kr/mombaby/prenatal" class="main-kv__link">엄마아기정보</router-link>
                    </li>
                </ul>
            </div>

            <div class="main-kv__text">
                <h2 class="tit">
                    <b>기적의 탄생, 생명의 시작</b>
                    <span>이대엄마아기병원</span>
                </h2>
            </div>
        </section>

        <section class="sec main-about">
            <div class="main__inner main-about__inner">
                <div>
                    <div class="main-about__img">
                        <div class="bg"></div>
                        <p class="tit1">이대엄마아기병원은 <br class="pc-none"> 고위험 산모와 고위험 신생아를</p>
                        <p class="tit2">집중적으로 케어하는 병원입니다.</p>
                    </div>
                    <div class="img">
                        <div class="img__inner">
                            <img src="@/assets/resource/img/past.png" class="past" alt="">
                            <img src="@/assets/resource/img/about__img01.png" class="present" alt="">
                        </div>
                        <div class="icon main__sircle"><img src="@/assets/resource/img/circle.svg" alt=""></div>
                        <div class="icon main__line"></div>
                    </div>
                </div>
                <div class="main-about__text">
                    <div class="yeal count">{{ count }}</div>
                    <p class="desc">이대엄마아기병원은 고위험 산모와 고위험 신생아를 집중적으로 케어하는 병원입니다. <br class="inner-none">
                        고위험 산모와 태아, 신생아의 건강관리를 위해 산과뿐만 아니라 중환자의학, <br class="inner-none">
                        그리고 신생아, 소아신경, 소아감염, 소아심장 등의 소아청소년분과와 소아흉부외과, <br class="inner-none">
                        소아영상의학과, 소아외과, 소아신경외과, 소아안과, 소아재활의학과 등의 <br class="inner-none">
                        의료진이 모두 유기적으로 협업하고 있습니다.</p>
                </div>
            </div>
        </section>

        <section class="sec row-mode">
            <div class="row-mode-bg"></div>
            <div class="bg-text">
                <p>Ewha Womans University Medical Center Ewha Womans University Medical Center Ewha Womans University Medical Center</p>
            </div>
            <div class="main__tit main__inner">
                <h2 class="tit">주요특징</h2>
                <p class="desc">기적의 탄생, 생명의 시작 이대엄마아기병원</p>
            </div>
            <div class="row-mode__inner">
                <!-- <div class="icon icon1"><img src="@/assets/resource/icon/row-icon01.svg" alt=""></div> -->
                <!-- <div class="icon icon2"><img src="@/assets/resource/icon/row-icon01.svg" alt=""></div> -->
                <ul class="row-mode__list">
                    <li class="row-mode__item bottom left">
                        <div class="row-mode__img">
                            <img src="@/assets/resource/img/row1.png" alt="">
                        </div>
                        <div class="row-mode__name">
                            <span class="num">01</span>
                            <h3>산모와 신생아만을 위한 <br>
                                맞춤형 병동 운영</h3>
                        </div>
                    </li>
                    <li class="row-mode__item column top">
                        <div class="row-mode__img">
                            <img src="@/assets/resource/img/row2.png" alt="">
                        </div>
                        <div class="row-mode__name">
                            <span class="num">02</span>
                            <h3>산후 출혈 FAST track system</h3>
                        </div>
                    </li>
                    <li class="row-mode__item bottom right">
                        <div class="row-mode__img">
                            <img src="@/assets/resource/img/row3.png" alt="">
                        </div>
                        <div class="row-mode__name">
                            <span class="num">03</span>
                            <h3>안전한 분만을 위한 시스템</h3>
                        </div>
                    </li>
                    <li class="row-mode__item column bottom">
                        <div class="row-mode__img">
                            <img src="@/assets/resource/img/row4.png" alt="">
                        </div>
                        <div class="row-mode__name">
                            <span class="num">04</span>
                            <h3>고위험신생아토탈케어</h3>
                        </div>
                    </li>
                    <li class="row-mode__item column top">
                        <div class="row-mode__img">
                            <img src="@/assets/resource/img/row5.png" alt="">
                        </div>
                        <div class="row-mode__name">
                            <span class="num">05</span>
                            <h3>24시간 철저한 신생아 관리</h3>
                        </div>
                    </li>
                    <li class="row-mode__item column bottom">
                        <div class="row-mode__img">
                            <img src="@/assets/resource/img/row6-1.png" alt="">
                        </div>
                        <div class="row-mode__name">
                            <span class="num">06</span>
                            <h3>24시간 365일 전원 Hot-Line</h3>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="progress-bar inner">
                <div class="bar"></div>
            </div>
        </section>

        <section class="sec medical-team">
            <div class="medical-team__bg">
                <ul class="medical-team__list">
                    <li class="medical-team__item" v-for="(i, index) in 30" :key="index">
                        <div class="item" ref="items"></div>
                    </li>
                </ul>
            </div>
            <div class="main__tit main__inner">
                <div>
                    <h2 class="tit">의료진 소개</h2>
                </div>
                <div class="select type2">
                    <div class="line-wrap">
                        <div :class="'line line' + i" v-for="i in 4" :key="i"></div>
                    </div>
                    <a href="javascript:;" class="select--btn" :class="{ active: select01 }" @click.prevent="activeselect01">센터선택</a>
                    <slide-up-down :active="select01">
                        <a href="javascript:;" class="select-option--btn" @click="setDoctorList()">센터선택</a>
                    </slide-up-down>
                    <slide-up-down :active="select01" class="select-option">
                        <a href="javascript:;" class="select-option--btn" v-for="center in centerList" :key="center" @click="setDoctorList(center); closeSelectBox();">{{center.deptNm}}</a>
                    </slide-up-down>
                </div>
            </div>
            <div class="medical-team__slider main__inner">
                <swiper :slidesPerView="4" :spaceBetween="30" :navigation="true" :breakpoints="{
                        1700: { spaceBetween: 30, slidesPerGroup: 4,slidesPerView: 4,},
                        1300: { spaceBetween: 30, slidesPerGroup: 3,slidesPerView: 3,},
                        1024: { spaceBetween: 16, slidesPerGroup: 1,slidesPerView: 'auto'},
                        0: { spaceBetween: 16, slidesPerGroup: 1, slidesPerView: 'auto'}
                    }" :modules="modules" class="medicalTeamSwiper">
                    <swiper-slide class="slide" v-for="doctor in doctorList" :key="doctor">
                        <h3 class="tit">{{selectedCenter ? selectedCenter.deptNm : doctor.centerNm}}</h3>
                        <div class="img">
                            <img :src="`/displayFile.do?attachNo=${ doctor.attachBag.thumbs[0].attachNo }`" :alt="doctor.attachBag.thumbs[0].altValue || '이미지'" v-if="doctor.attachBag.thumbs">
                        </div>
                        <div class="name">
                            <!-- <h4>{{doctor.name}}</h4> -->
                            <h4>{{doctor.name}} 교수</h4>
                            <!-- 여백 X -->
                            <!-- <p>{{doctor.position ? `교수 / ${doctor.position}` : '교수'}}</p> -->
                            <!-- 여백버전 -->
                            <!-- <p :class="{active: !doctor.position}">{{doctor.position ? `${doctor.position}` : '.'}}</p> -->
                        </div>
                        <p class="desc">
                            {{doctor.detailField}}
                        </p>
                        <div class="hover">
                            <h3 class="tit">{{selectedCenter ? selectedCenter.deptNm : doctor.centerNm}}</h3>
                            <div class="name">{{doctor.name}} 교수</div>
                            <!-- 환자번호 있을 때 -->
                            <div class="text-box" v-if="$store.getters.getStatus && $store.state.myInfoStore.ptNo ">
                                <template v-if="doctor.firstDate">
                                    <p v-html="getDate(doctor.firstDate)"></p>
                                    <p v-html="getTime(doctor.firstDate)"></p>
                                </template>
                                <!-- <p>{{setDeptPlace(doctor)}}</p> -->
                                <p v-html="setDeptPlace(doctor)"></p>
                            </div>
                            <!-- 환자번호 없을 때 -->
                            <div class="text-box" v-else>
                                <p class="log">
                                    <span class="font-sub">로그인 후 환자번호조회 시</span><br>
                                    빠른 예약 일정 <br>
                                    확인이 가능합니다.
                                </p>
                            </div>
                            <div class="hover__btn">
                                <a href="javascript:;" @click="quickReservation(doctor)" class="btn">
                                    <span class="text">빠른예약</span>
                                    <span class="icon"><img src="@/assets/resource/icon/arrow02.svg" alt=""></span>
                                </a>
                                <a :href="`/kr/doctorInfo?drSid=${doctor.drSid}&deptCd=${doctor.mainDeptCd}`" target="_blank" class="btn">
                                    <span class="text">의료진소개</span>
                                    <span class="icon"><img src="@/assets/resource/icon/arrow02.svg" alt=""></span>
                                </a>
                            </div>
                        </div>
                    </swiper-slide>
                </swiper>
            </div>

        </section>

        <section class="sec card main__inner">
            <div class="main__tit">
                <div>
                    <h2 class="tit">이용안내</h2>
                </div>
            </div>
            <ul class="card__list">
                <li class="card__item">
                    <a href="/kr/information/guide" class="card__link">
                        <span class="num">01</span>
                        <span class="tit">진료안내</span>
                        <div class="icon"><img src="@/assets/resource/img/main-img01.svg" alt=""></div>
                        <span class="hover"></span>
                    </a>
                </li>
                <li class="card__item">
                    <a href="/kr/information/satisfaction" class="card__link">
                        <span class="num">02</span>
                        <span class="tit">고객서비스</span>
                        <div class="icon"><img src="@/assets/resource/img/main-img02.svg" alt=""></div>
                        <span class="hover"></span>
                    </a>
                </li>
                <li class="card__item">
                    <a href="/kr/mc_faq/list" class="card__link">
                        <span class="num">03</span>
                        <span class="tit">자주묻는질문</span>
                        <div class="icon"><img src="@/assets/resource/img/main-img03.svg" alt=""></div>
                        <span class="hover"></span>
                    </a>
                </li>
                <li class="card__item">
                    <a href="/kr/information/call" class="card__link">
                        <span class="num">04</span>
                        <span class="tit">안내전화</span>
                        <div class="icon"><img src="@/assets/resource/img/main-img04.svg" alt=""></div>
                        <span class="hover"></span>
                    </a>
                </li>
            </ul>
        </section>

        <section class="sec video">
            <div class="video__bg video__bg1"><img src="@/assets/resource/img/bg_img1.png" alt=""></div>
            <div class="video__bg video__bg2"><img src="@/assets/resource/img/bg_img2.png" alt=""></div>
            <div class="main__inner">
                <div class="video__top">
                    <div class="video__text">
                        <div class="main__tit">
                            <div>
                                <h2 class="tit">온라인출산교실</h2>
                            </div>
                        </div>
                        <h3 class="video__tit">{{selectedArticle.title}}</h3>
                        <p class="video__desc">{{$commonUtils.removeTags(selectedArticle.content)}}</p>
                    </div>
                    <div class="video__swiper video__swiper1">
                        <swiper :spaceBetween="10" :navigation="true" :thumbs="{ swiper: thumbsSwiper }" :modules="modules" class="videoSwiper1">
                            <swiper-slide class="slide" v-for="article in articleList" :key="article">
                                <!-- <img :src="`https://img.youtube.com/vi/${$commonUtils.getYoutubeId(article)}/sddefault.jpg`" alt="이미지" v-if="article.linkUrl && article.linkUrl.indexOf('youtu') > -1"> -->
                                <iframe style="width:100%; height: 100%;" :src="`https://www.youtube.com/embed/${$commonUtils.getYoutubeId(article)}`" title="YouTube video player" frameborder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen v-if="article.linkUrl"></iframe>
                            </swiper-slide>
                        </swiper>
                    </div>
                    <h3 class="video__tit">{{selectedArticle.title}}</h3>

                </div>
                <div class="video__swiper video__swiper2">
                    <swiper @swiper="setThumbsSwiper" :slidesPerView="'auto'" :freeMode="true" :watchSlidesProgress="true" :modules="modules" :breakpoints="{
                        720: { spaceBetween: 40 },
                        0: { spaceBetween: 16 }
                    }" class="videoSwiper2">
                        <swiper-slide class="slide" v-for="article in articleList" :key="article">
                            <a href="javascript:;" @click="selectArticle(article)">
                                <div class="slide__img">
                                    <img :src="`https://img.youtube.com/vi/${$commonUtils.getYoutubeId(article)}/mqdefault.jpg`" alt="이미지" v-if="article.linkUrl && article.linkUrl.indexOf('youtu') > -1">
                                    <div class="hover"></div>
                                </div>
                                <div class="tit">{{article.title}}</div>
                            </a>
                        </swiper-slide>
                    </swiper>
                </div>
            </div>
        </section>


        <section class="sec main-board">
            <h2 class="main-board__tit">고맙습니다</h2>
            <p class="main-board__desc">새로운 생명을 만날 인생 최고의 순간</p>
            <!-- 메인 스와이퍼 -->
            <swiper :breakpoints="{
                    720: { spaceBetween: 40 },
                    0: { spaceBetween: 16 }
                }" :autoplay="{ delay: 2000 }" :slidesPerView="'auto'" :modules="modules" :centeredSlides="true" :loop="true" class="main-board-swiper">
                <swiper-slide class="main-board__item" v-for="(item, index) in thanksList" :key="index">
                    <router-link :to="`/${$store.getters.getLang}/${item.boardId}/view?boardNo=${item.boardNo}&articleNo=${item.articleNo}`">
                        <div class="main-board__box">
                            <h3 class="tit">{{ item.title }}</h3>
                            <p class="desc">{{ $commonUtils.removeTags(item.content) }}</p>
                        </div>
                        <div class="date">
                            <div>
                                <span v-if="thanksPeoples(item)">
                                    고마운 선생님 : {{thanksPeoples(item)}}
                                </span>
                            </div>
                            <span>{{$commonUtils.timestampToDate(item.createdDt)}}</span>
                        </div>
                    </router-link>
                </swiper-slide>
            </swiper>
        </section>

    </div>
    <kr_FirstReserveInputPopUp :popupVisible="firstVisible" @hide-popup="hidePopup" />
    <kr_AlarmTalkInputPopup :popupVisible="alarmVisible" @hide-popup="hidePopup" />
</template>


<script>

    import { ref, onMounted } from 'vue';
    import SlideUpDown from 'vue-slide-up-down';
    import { Swiper, SwiperSlide } from 'swiper/vue';
    import { FreeMode, Pagination, Navigation, Thumbs, Autoplay } from 'swiper/modules';
    import 'swiper/css';
    import 'swiper/css/free-mode';
    import 'swiper/css/navigation';
    import 'swiper/css/thumbs';
    // import required modules

    import { gsap, Power1 } from "gsap";
    import ScrollTrigger from "gsap/ScrollTrigger";
    gsap.registerPlugin(ScrollTrigger);

    export default {
        name: "MyComponent",
        components: {
            SlideUpDown,
            Swiper,
            SwiperSlide,
        },
        setup() {
            // GSAP 카운트 관련 변수
            const count = ref(1887);

            // Swiper 관련 변수
            const thumbsSwiper = ref(null);

            // Swiper 썸네일 설정 함수
            const setThumbsSwiper = (swiper) => {
                thumbsSwiper.value = swiper;
            };

            onMounted(() => {
                gsap.to(count, {
                    value: new Date().getFullYear(), // 목표 숫자
                    scrollTrigger: {
                        trigger: '.main-about', // 트리거할 요소
                        start: '-100px top', // 스크롤이 트리거 영역에 닿을 때
                        once: true, // 한 번만 실행되도록 설정
                    },
                    duration: 3, // 애니메이션 지속 시간
                    onUpdate: () => {
                        count.value = Math.floor(count.value); // 소수점 제거
                    },
                });

                gsap.from('.main-about .present', { scrollTrigger: { trigger: '.main-about', start: '-100px top', }, opacity: 0, });

            });

            return {
                count,
                thumbsSwiper,
                setThumbsSwiper,
                modules: [FreeMode, Navigation, Thumbs, Pagination, Autoplay],
            };

        },
        data() {
            return {
                isMobile: window.innerWidth < 768 ? true : false,
                activeSection: 'diagnosis',
                select01: false,
                lineCnt: 0,
                lineList: [],
                popupCnt: 0,
                popupList: [],
                main_popup: false,

                firstVisible: false,
                alarmVisible: false,

                centerList: [],
                selectedCenter: '',
                orgList: [],
                doctorList: [],

                articleList: [],
                selectedArticle: {},

                thanksList: [],
                isScrolled: false,
            };
        },
        methods: {
            setDeptPlace(doctor) {
                const centerNm = this.selectedCenter ? this.selectedCenter.deptNm : doctor.centerNm
                let placeNm = ''
                if (centerNm.indexOf('산과센터') > -1) {
                    placeNm = '2층 고위험산과센터/산부인과'
                }
                if (centerNm.indexOf('집중치료센터') > -1) {
                    placeNm = '지하 1층 소아청소년과, \n2층 고위험 신생아 집중치료센터'
                }
                if (centerNm.indexOf('출혈센터') > -1) {
                    placeNm = '3층 외과중환자실'
                }
                if (centerNm.indexOf('아기수술센터') > -1) {
                    placeNm = '2층 고위험 신생아 집중치료센터'
                }

                placeNm = placeNm.replace(/\n/g, '<br>');
                return placeNm
            },
            thanksPeoples(article) {
                const baseText = article.item1 || ''
                let doctorNames = []
                if (article.refDoctorList) {
                    for (let i of article.refDoctorList) {
                        if (!i.drName) continue
                        if(i.deptNm){
                            doctorNames.push(`${i.deptNm} ${i.drName} 선생님`)
                        }else{
                            doctorNames.push(`${i.drName} 선생님`)
                        }
                    }
                }
                if (baseText && doctorNames.length > 0) {
                    return `${baseText}, ${doctorNames.join(', ')}`
                }
                if (baseText) {
                    return baseText
                }
                if (doctorNames.length > 0) {
                    return doctorNames.join(', ')
                }
                return ''
            },
            getThanksList() {
                const boardNo = 10
                const params = {
                    hospId: this.$store.getters.getHost,
                    boardNo: boardNo,
                    startIndex: 1,
                    pageRow: 10,
                    title: '',
                    content: '',
                    searchKeyword: '',
                    item18: 'O'
                }
                this.axios.get(this.api.article.list + boardNo, {
                    params: params
                })
                    .then(res => {
                        this.thanksList = res.data.list
                    })
            },
            selectArticle(article) {
                this.selectedArticle = article
            },
            getClassList() {
                const boardNo = 15
                const params = {
                    hospId: this.$store.getters.getHost,
                    boardNo: boardNo,
                    startIndex: 1,
                    pageRow: 10,
                    title: '',
                    content: '',
                    searchKeyword: '',
                }
                this.axios.get(this.api.article.list + boardNo, {
                    params: params
                })
                    .then(res => {
                        this.articleList = res.data.list
                        if (this.articleList) {
                            this.selectedArticle = {
                                title: res.data.list[0].title || '',
                                content: res.data.list[0].content || ''
                            }
                        }
                    })
            },
            // setCenterNm(doctor){
            //     if(this.selectedCenter){
            //         return this.selectedCenter.deptNm
            //     }

            //     let result = ''
            //     console.log(this.centerList)
            //     const centerArr = this.centerList.map(i => i.deptCd)
            //     if(doctor.doctorDeptList && doctor.doctorDeptList.length > 0){
            //         for(let i of doctor.doctorDeptList){
            //             if(i.deptType == 1 && centerArr.includes(i.deptCd) && !result){
            //                 result = i.deptNm
            //             }
            //         }
            //     }
            //     return result
            // },
            setDoctorList(center) {
                this.selectedCenter = center

                this.closeSelectBox(); // 선택 후 박스 닫기

                if (!center) {
                    this.doctorList = this.orgList
                    return
                }

                this.doctorList = this.orgList
                    .filter(org => org.doctorDeptList?.some(dept => dept.deptType == 1 && dept.deptCd == center.deptCd))
                    .map(org => org)
            },
            showPopup(param) {
                this[param] = true
            },
            hidePopup(param) {
                this[param] = false
            },
            getMainBanner() {
                const param = {
                    hospId: this.$store.getters.getHost
                }
                this.axios.get(this.api.banner.main, {
                    params: param
                }).then(res => {
                    // 띠배너
                    // const line = res.data.line
                    // this.lineCnt = line.totCnt
                    // this.lineList = line.list

                    // if(this.lineCnt > 0){
                    //     this.main_line = true

                    //     const oneDay = 24 * 60 * 60 * 1000
                    //     const now = new Date().getTime()

                    //     const lineLastVisit = localStorage.getItem('lineTime')
                    //     const lineLastVisitTime = lineLastVisit ? parseInt(lineLastVisit, 10) : null
                    //     const lineTimeSinceLastVisit = lineLastVisitTime ? now - lineLastVisitTime : null

                    //     if (lineLastVisitTime && lineTimeSinceLastVisit < oneDay) {
                    //         this.main_line = false;
                    //     }
                    // }else{
                    //     this.main_line = false
                    // }

                    // 팝업
                    const popup = res.data.popup
                    this.popupCnt = popup.totCnt
                    this.popupList = popup.list

                    if (this.popupCnt > 0) {
                        this.main_popup = true

                        const oneDay = 24 * 60 * 60 * 1000
                        const now = new Date().getTime()

                        const popupLastVisit = localStorage.getItem('popupTime_mom')
                        const popupLastVisitTime = popupLastVisit ? parseInt(popupLastVisit, 10) : null
                        const popupTimeSinceLastVisit = popupLastVisitTime ? now - popupLastVisitTime : null

                        if (popupLastVisitTime && popupTimeSinceLastVisit < oneDay) {
                            this.main_popup = false;
                        }

                        // Swiper 초기화
                        this.$nextTick(() => {
                            this.popupGsap();
                        });
                    } else {
                        this.main_popup = false
                    }
                })
            },
            popupGsap() {
                gsap.from('.popup2', { x: '70', opacity: 0, delay: 1.4, duration: 1 });
            },
            closePopup() {
                this.main_popup = false;
                const now = new Date().getTime()
                localStorage.setItem('popupTime_mom', now.toString())
            },
            main_popup_close() {
                this.main_popup = false;
            },
            mainEffect() {
                // sec1 kv
                gsap.from('.main-kv__list', { y: '50', opacity: 0, delay: 1.4, duration: .8, stagger: 0.3, });
                gsap.to('.main-kv__text .tit', { y: '50', delay: 4, duration: .8, opacity: 0 });

                // sec2
                gsap.from('.main-about__img .tit1', { scrollTrigger: { trigger: '.main-about', start: 'top center' }, x: 50, duration: 1, opacity: 0 })
                gsap.from('.main-about .img__inner', { scrollTrigger: { trigger: '.main-about', start: 'top center' }, y: 50, duration: 1, opacity: 0, })
                gsap.from('.main-about .main__sircle', { scrollTrigger: { trigger: '.main-about', start: 'top center' }, duration: 1, delay: 1, opacity: 0, })
                gsap.from('.main-about .main__line', { scrollTrigger: { trigger: '.main-about', start: 'top center' }, duration: 1, delay: 1, scale: 0, opacity: 0, })
                gsap.from('.main-about .count', { scrollTrigger: { trigger: '.main-about', start: 'top center' }, x: 300, duration: 1.5, delay: .3, opacity: 0, })
                gsap.from('.main-about .desc', { scrollTrigger: { trigger: '.main-about', start: 'top center' }, y: 40, duration: 1.3, delay: .3, opacity: 0, })

                // sec3
                gsap.from('.row-mode .main__tit .tit', { scrollTrigger: { trigger: '.row-mode', start: 'top center' }, x: 50, duration: 1, opacity: 0 })
                gsap.from('.row-mode .main__tit .desc', { scrollTrigger: { trigger: '.row-mode', start: 'top center' }, x: 50, duration: 1.3, opacity: 0 })

                // sec4
                gsap.from('.medical-team .main__tit .tit', { scrollTrigger: { trigger: '.medical-team', start: 'top center' }, x: 50, duration: 1, opacity: 0 })
                gsap.from('.medical-team .main__tit .select.type2 .select--btn', { scrollTrigger: { trigger: '.medical-team', start: 'top center' }, x: 50, duration: 1.3, opacity: 0 })
                gsap.from('.medical-team__slider', { scrollTrigger: { trigger: '.medical-team', start: 'top center' }, x: 50, duration: 1.3, delay: .7, opacity: 0 })
                gsap.from('.medical-team__list .medical-team__item', { scrollTrigger: { trigger: '.medical-team', start: 'top center' }, duration: 1.3, delay: .7, opacity: 0 })

                const timeline = gsap.timeline({ paused: true });

                timeline
                    .to('.line:nth-child(1)', { width: '100%', duration: .3 }) // Line 1: Top
                    .to('.line:nth-child(2)', { height: '100%', duration: .3 }) // Line 2: Right
                    .to('.line:nth-child(3)', { width: '100%', duration: .3 }) // Line 3: Bottom
                    .to('.line:nth-child(4)', { height: '100%', duration: .3 }); // Line 4: Left

                const element = document.querySelector('.select.type2');

                element.addEventListener('mouseenter', () => timeline.play());
                element.addEventListener('mouseleave', () => timeline.reverse());


                // sec5
                gsap.from('.card .main__tit .tit', { scrollTrigger: { trigger: '.card', start: 'top center' }, x: 50, duration: 1, opacity: 0 })
                gsap.from('.card__item', { scrollTrigger: { trigger: '.card', start: 'top center' }, y: '200', opacity: 0, delay: .2, duration: 1.5, stagger: 0.2, });

                // sec6 
                gsap.from('.video .main__tit .tit', { scrollTrigger: { trigger: '.video', start: '-20% center' }, x: 50, duration: 1, opacity: 0 })
                gsap.from('.video .video__tit', { scrollTrigger: { trigger: '.video', start: '-20% center' }, x: 50, duration: 1.5, opacity: 0 })
                gsap.from('.video__desc', { scrollTrigger: { trigger: '.video', start: '-20% center' }, y: 30, duration: 1, opacity: 0, })
                gsap.from('.video__swiper1', { scrollTrigger: { trigger: '.video', start: '-20% center' }, x: 50, duration: 1.5, delay: .3, opacity: 0 })
                gsap.from('.video__swiper2', { scrollTrigger: { trigger: '.video', start: '-20% center' }, y: 50, duration: 1.5, delay: .3, opacity: 0 })

                // sec7
                gsap.from('.main-board__tit', { scrollTrigger: { trigger: '.main-board', start: '-20% center' }, y: 50, duration: 1, opacity: 0 })
                gsap.from('.main-board__desc', { scrollTrigger: { trigger: '.main-board', start: '-20% center' }, y: 50, duration: 1, delay: .2, opacity: 0 })
                gsap.from('.main-board .swiper', { scrollTrigger: { trigger: '.main-board', start: '-20% center' }, y: 50, duration: 1, delay: .4, opacity: 0 })
            },
            introEffect() {
                // intro
                gsap.to('.intro__bg1', { height: 0, delay: 1 });
                gsap.from('.intro__bg2', { height: 150 + 'vh', delay: 1.2, duration: 0.5, ease: Power1.easeInOut });
                gsap.from('.intro__bg2 div', { height: 150 + 'vh', borderTopLeftRadius: '50%', borderTopRightRadius: '50%', delay: 1.2, duration: 0.5, ease: Power1.easeInOut });
                gsap.to('.intro__bg3', { height: 0, borderRadius: 0, delay: 1, duration: 1, ease: Power1.easeInOut });
                gsap.to('.intro__bg3', { borderRadius: 0, delay: 1.5, duration: 1, ease: Power1.easeInOut });
                gsap.to('.intro', { height: 0, delay: 1.5 });
                // intro
            },
            scrollTo(id) {
                const element = document.getElementById(id);
                if (element) {
                    element.scrollIntoView({ behavior: 'smooth' });
                }
            },
            handleIntersection(entries) {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        this.activeSection = entry.target.id;
                    }
                });
            },
            activeselect01() {
                this.select01 = !this.select01;
            },
            closeSelectBox() {
                this.select01 = false; // 셀렉트 박스 닫기
            },
            splitText(selector) {
                // sec2
                const element = document.querySelector(selector);
                if (!element) return;

                const text = element.textContent;
                const splitText = text.split("").map(char => {
                    if (char === " ") return `<span>&nbsp;</span>`;
                    return `<span class="letter">${char}</span>`;
                }).join("");

                element.innerHTML = splitText;
            },
            noteGsap() {
                // gsap.to('.note', { scrollTrigger: { trigger: '.main', start: 'top top', end: 'bottom top', toggleClass: { targets: '.note', className: 'on' } } })
                // gsap.to('.note', { scrollTrigger: { trigger: '.main', start: 'top top', end: 'top top', scrub: 10,  }, y: '50vh', opacity: 0 })
                //     .to('.note', { scrollTrigger: { trigger: '.main', start: 'top top', end: 'top top', scrub: 10,  }, opacity: 1 })
                const tl2 = gsap.timeline({
                    scrollTrigger: {
                        trigger: '.main',
                        start: 'top top',
                        end: 'top top',
                        scrub: 10,
                    }
                });

                tl2.to('.note', { y: '10vh', opacity: 0 })
                    .to('.note', { y: '40vh', opacity: 0 })
                    .to('.note', { y: '61vh', opacity: 1 });

                gsap.to('.note', { scrollTrigger: { trigger: '.footer', start: 'top bottom', toggleClass: { targets: '.note', className: 'active' } } });

            },
            infoGsap() {
                // 텍스트를 분리 sec2
                this.splitText('.main-about__img .tit2');

                // GSAP 애니메이션 sec2
                gsap.from('.main-about', { scrollTrigger: { trigger: '.main-about', start: '-188px top', pin: true } });
                gsap.fromTo('.letter', { x: 300, opacity: 0 }, {
                    scrollTrigger: { trigger: ".main-about", start: "-188px top" },
                    x: 0,
                    opacity: 1,
                    duration: 1.5,
                    ease: 'power2.easeOut',
                    stagger: {
                        from: 'start',
                        amount: 0.8
                    }
                }
                );
            },

            rowModeGsap() {
                // 가로모드
                let pinBox = gsap.utils.toArray('.row-mode__item');
                // let pinBox = gsap.utils.toArray('.row-mode__list');
                gsap.to('.row-mode', { scrollTrigger: { trigger: '.row-mode', start: '-88px top', end: () => '+=' + document.querySelector('.row-mode__list').offsetWidth, scrub: 2, pin: true } });
                gsap.to('.row-mode__list', { scrollTrigger: { trigger: '.row-mode', start: '-88px top', end: () => '+=' + document.querySelector('.row-mode__list').offsetWidth, scrub: 3 }, ease: 'none', xPercent: -100 });
                // gsap.to(pinBox, { scrollTrigger: { trigger: 't.row-mode', start: 'top top', end: () => '+=' + document.querySelector('.row-mode__list').offsetWidth, scrub: 3 }, ease: 'none', xPercent: -100 * (pinBox.length - 1) });
                gsap.from('.bg-text p', { scrollTrigger: { trigger: '.row-mode', start: 'top top', end: () => '+=' + document.querySelector('.row-mode__list').offsetWidth, scrub: 10 }, xPercent: -10 * (pinBox.length - 1) });
                gsap.to('.progress-bar .bar', { scrollTrigger: { trigger: '.row-mode', start: '-88px top', end: () => '+=' + document.querySelector('.row-mode__list').offsetWidth, scrub: 2 }, ease: 'none', width: '100%' });
                gsap.from('.row-mode-bg', { scrollTrigger: { trigger: '.row-mode', start: '-88px top', end: () => '+=' + document.querySelector('.row-mode__list').offsetWidth, scrub: 5 }, opacity: 0 });

                gsap.from('.row-mode__text', { scrollTrigger: { trigger: '.row-mode', start: '20% center' }, ease: 'power1.out', y: 30, duration: 0.8, opacity: 0 });
                gsap.from('.row-mode__list', { scrollTrigger: { trigger: '.row-mode', start: '20% center' }, ease: 'power1.out', x: 100, duration: 0.8, delay: 0.3, opacity: 0 });
                gsap.from('.bg-text', { scrollTrigger: { trigger: '.row-mode', start: '20% center' }, ease: 'power1.out', duration: 1, delay: 0.6, opacity: 0 });
            },

            checkScreenSize() {
                // 화면 너비가 720px 이상일 때만 함수 실행
                if (window.innerWidth >= 1024) {
                    this.introEffect()
                    this.infoGsap()
                    this.rowModeGsap(); // rowModeGsap 함수 실행
                    this.mainEffect()
                    this.noteGsap()
                } else {
                    // 가로모드 라인효과
                    gsap.from('.bg-text p', { scrollTrigger: { trigger: '.row-mode', start: 'top top', end: () => '+=' + document.querySelector('.row-mode').offsetHeight * 5, scrub: 10 }, xPercent: -50 });
                }
            },
            quickReservation(doctor) {
                this.$store.state.reserveStore.quickReserve = doctor
                this.$router.push('/kr/reserve/reservation')
            },
            goReservation() {
                this.$store.state.patInfoStore = {}
                this.$router.push('/kr/reserve/reservation')
            },
            getDate(firstDate) {
                //yyyyMMdd HH:mm 형식의 데이터를 yyyy.MM.dd(요일) 형식으로 변환
                const year = firstDate.substring(0, 4)
                const month = firstDate.substring(4, 6)
                const day = firstDate.substring(6, 8)
                const week = ['일', '월', '화', '수', '목', '금', '토']

                const date = new Date(`${year}-${month}-${day}`)
                const weekDay = week[date.getDay()]

                return `${year}.${month}.${day}(${weekDay})`
            },
            getTime(firstDate) {
                //yyyyMMdd HH:mm 형식의 데이터를 HH:mm 형식으로 변환
                const hour = firstDate.substring(9, 11)
                const minute = firstDate.substring(12, 14)

                return `${hour}:${minute}`
            },
            handleScroll() {
                // 스크롤 위치가 50px 이상이면 'on' 클래스 추가
                if (window.scrollY >= 100) {
                    this.isScrolled = true;
                } else {
                    this.isScrolled = false;
                }
            },
        },
        async mounted() {
            window.onpopstate = () => {
                window.scrollTo({top: sessionStorage.getItem('currentSection')})
            }
            this.getMainBanner()
            const center = await this.axios.get(this.api.department.list, {
                params: {
                    hospId: this.$store.getters.getHost,
                    deptType: 1,
                    startIndex: 1,
                    langType: this.$store.getters.getLang,
                    orderType: 'sortOrd'
                }
            })
            // this.centerList = center.data
            this.centerList = center.data.filter(item => item.deptCd !== 'mom04');

            const doctor = await this.axios.get(this.api.doctor.doctorList, {
                params: {
                    startIndex: 1,
                    drName: this.drName,
                    pageRow: 100,
                    langCd: this.$store.getters.getLang,
                    hospId: this.$store.getters.getHost
                }
            })
            const cnt = doctor.data.doctorTotCnt
            if (cnt > 0) {
                this.orgList = doctor.data.doctorList
                this.doctorList = doctor.data.doctorList

                const centerArr = this.centerList.map(i => i.deptCd)
                for (let i of this.orgList) {
                    if (i.doctorDeptList && i.doctorDeptList.length > 0) {
                        for (let j of i.doctorDeptList) {
                            if (j.deptType == 1 && centerArr.includes(j.deptCd) && !i.centerNm) {
                                i.centerNm = j.deptNm
                            }
                        }
                    }
                }
            }
            this.getClassList()
            this.getThanksList()

            // 초기 화면 크기 체크
            this.checkScreenSize();
            // 화면 크기 변경시 체크
            window.addEventListener('resize', this.checkScreenSize);

            const options = {
                root: null,
                rootMargin: '0px',
                threshold: 0.5, // 섹션의 절반 이상이 보일 때 active 설정
            };

            const observer = new IntersectionObserver(this.handleIntersection, options);
            console.log(observer)

            const sections = document.querySelectorAll('#diagnosis, #education, #research, #book, #news, #thank');
            sections.forEach(section => {
                observer.observe(section);
            });



            // 배경효과
            const items = document.querySelectorAll(".medical-team__item .item");
            // 색상 리스트
            const colors = [
                // "#FCEFF5", "#f3f7f6", "#F2F6F6", "#fff",
                "#f3f7f6", "#F2F6F6", "#fff",
            ];

            // 각 .item에 대해 랜덤 애니메이션 적용
            items.forEach(item => {
                const tl = gsap.timeline({
                    repeat: -1,
                    yoyo: true
                });

                // 각 애니메이션 효과를 담은 배열
                const effects = [
                    { property: 'borderTopLeftRadius', value: '100%', color: colors[0] },
                    { property: 'borderTopLeftRadius', value: '0%', color: colors[0] },
                    { property: 'borderTopRightRadius', value: '100%', color: colors[1] },
                    { property: 'borderTopRightRadius', value: '0%', color: colors[1] },
                    { property: 'borderBottomLeftRadius', value: '100%', color: colors[2] },
                    { property: 'borderBottomLeftRadius', value: '0%', color: colors[2] },
                    { property: 'borderBottomRightRadius', value: '100%', color: colors[3] },
                    { property: 'borderBottomRightRadius', value: '0%', color: colors[3] },
                ];

                // 랜덤하게 배열을 섞음
                effects.sort(() => Math.random() - 0.5);

                // 랜덤으로 섞인 순서대로 애니메이션 적용
                effects.forEach(effect => {
                    tl.to(item, {
                        [effect.property]: effect.value,
                        backgroundColor: effect.color,
                        duration: 3
                    });
                });
            });
            window.addEventListener('scroll', this.handleScroll);
        },
        beforeUnmount() {
            // 컴포넌트가 파괴될 때 resize 이벤트 리스너 제거
            window.removeEventListener('resize', this.checkScreenSize);
            const elements = document.querySelector('.main').childNodes
            const count = document.querySelector('.main').childElementCount
            if(count > 0){
                let sectionY = 0
                const curY = window.scrollY
                elements.forEach((item, index) => {
                    if(index > 0){
                        const elementY = item.getBoundingClientRect().top + curY
                        sectionY = Math.min(elementY, curY)
                        if(curY > elementY){
                            sessionStorage.setItem('currentSection', sectionY)
                        }
                    }
                })
            }
        },
    };
</script>